import { usePaymentContext } from "@bokio/contexts/PaymentContext/PaymentContext";
import { Notice } from "@bokio/designsystem/components/Notice/Notice";
import { Link } from "@bokio/elements/Link/Link";
import { BankLangFactory } from "@bokio/lang";
import { useCompanyInfo } from "@bokio/mobile-web-shared/core/contexts/CompanyInfoContext/CompanyInfoContext";
import { getRoute } from "@bokio/shared/route";
import { formatMessage } from "@bokio/shared/utils/format";

import type { LegacyMarginProp } from "@bokio/designsystem/infrastructure/legacyComponentInterop/legacyMarginProp";
import type { FC } from "react";

interface SveaKycBlockServicesNoticeProps {
	testId?: string;
	margin?: LegacyMarginProp;
}

export const SveaKycBlockServicesNotice: FC<SveaKycBlockServicesNoticeProps> = ({ testId, margin }) => {
	const bankLang = BankLangFactory();
	const {
		companyInfo: { Id: companyId },
	} = useCompanyInfo();
	const { currentUserPermission } = usePaymentContext();

	if (!currentUserPermission.CanSignPayment) {
		return null;
	}

	function toKycScene(message: string) {
		return <Link route={getRoute("sveaKycScene", { company: companyId })}>{message}</Link>;
	}
	return (
		<Notice margin={margin ?? ["bottom", "top"]} testId={testId} color={"error"} collapsible={false}>
			{formatMessage(bankLang.SveaKyc_BlockServices_Notice, toKycScene)}
		</Notice>
	);
};
